import { UserRoleEnum } from 'src/graphql/schema';

export const getMemberSortPriority = (user: { id: string; role: UserRoleEnum }, profileId: string) => {
  if (user.id === profileId) return 0; // Current user always first
  if (user.role === UserRoleEnum.Owner) return 1; // Owners second
  return 2; // Everyone else
};
